import React from "react";
import { Media } from "../Media";
import Vertical from "./Vertical";
import Horizontal from "./Horizontal";
import NarrowRightAligned from "./NarrowRightAligned";
import Bulleted from "./Bulleted";

function Cards({
  cards = [],
  title,
  titleColour,
  eyebrow,
  layout = "vertical",
  backgroundColour,
  description,
  descriptionColour,
  hasBottomMargin,
  hasTopMargin,
  hideTitle,
  hideIndexNumberDisplay,
  numberOfColumns,
  image,
  mobileImage,
  cta,
}) {
  const { ctaLabel, ctaUrl } = cta || {};

  const ctaProps = {
    ctaLabel: ctaLabel,
    ctaUrl: ctaUrl,
  };

  if (layout === "vertical") {
    return (
      <>
        <Media lessThan="l">
          <Horizontal
            description={description}
            descriptionColour={descriptionColour}
            cards={cards}
            mainTitle={title}
            titleColour={titleColour}
            backgroundColour={backgroundColour}
            hasTopMargin={hasTopMargin}
            hasBottomMargin={hasBottomMargin}
            hideTitle={hideTitle}
            hideIndexNumberDisplay={hideIndexNumberDisplay}
            numberOfColumns={numberOfColumns}
            mobileImage={mobileImage}
            layout={layout}
            eyebrow={eyebrow}
            ctaProps={ctaProps}
          />
        </Media>
        <Media greaterThanOrEqual="l">
          <Vertical
            description={description}
            descriptionColour={descriptionColour}
            cards={cards}
            mainTitle={title}
            titleColour={titleColour}
            backgroundColour={backgroundColour}
            hideTitle={hideTitle}
            hideIndexNumberDisplay={hideIndexNumberDisplay}
            image={image}
            eyebrow={eyebrow}
            ctaProps={ctaProps}
            hasTopMargin={hasTopMargin}
            hasBottomMargin={hasBottomMargin}
          />
        </Media>
      </>
    );
  }
  if (layout === "narrow right aligned") {
    return (
      <NarrowRightAligned
        description={description}
        descriptionColour={descriptionColour}
        cards={cards}
        mainTitle={title}
        titleColour={titleColour}
        backgroundColour={backgroundColour}
        hasTopMargin={hasTopMargin}
        hasBottomMargin={hasBottomMargin}
        hideTitle={hideTitle}
        hideIndexNumberDisplay={hideIndexNumberDisplay}
        eyebrow={eyebrow}
        ctaProps={ctaProps}
      />
    );
  }

  if (layout === "bulleted") {
    return (
      <Bulleted
        cards={cards}
        eyebrow={eyebrow}
        ctaProps={ctaProps}
        hideIndexNumberDisplay={hideIndexNumberDisplay}
        description={description}
        descriptionColour={descriptionColour}
        mainTitle={title}
        titleColour={titleColour}
        backgroundColour={backgroundColour}
        hideTitle={hideTitle}
        hasTopMargin={hasTopMargin}
        hasBottomMargin={hasBottomMargin}
      />
    );
  }

  return (
    <Horizontal
      description={description}
      descriptionColour={descriptionColour}
      cards={cards}
      mainTitle={title}
      titleColour={titleColour}
      backgroundColour={backgroundColour}
      hasTopMargin={hasTopMargin}
      hasBottomMargin={hasBottomMargin}
      hideTitle={hideTitle}
      hideIndexNumberDisplay={hideIndexNumberDisplay}
      numberOfColumns={numberOfColumns}
      eyebrow={eyebrow}
      layout={layout}
      ctaProps={ctaProps}
    />
  );
}

export default Cards;
